/** Collapsed mailer used for shipping — not the assembled box size shown on products. */
export const COLLAPSED_SHIPPING_PACKAGE_IN = {
  length: 18,
  breadth: 12,
  height: 1.5,
  maxBoxes: 5,
};

export function countCartBoxes(cart) {
  return (cart || []).reduce(
    (sum, item) => sum + Math.max(1, Number(item.quantity) || 1),
    0,
  );
}

/**
 * Shipping footprint for collapsed boxes in standard mailers.
 * One mailer holds up to 5 boxes; extra boxes use additional stacked mailers (height only).
 */
export function computeShippingDimensionsInches(totalBoxes) {
  const boxes = Math.max(1, Number(totalBoxes) || 1);
  const { length, breadth, height, maxBoxes } = COLLAPSED_SHIPPING_PACKAGE_IN;
  const packages = Math.ceil(boxes / maxBoxes);

  return {
    length,
    breadth,
    height: height * packages,
    packages,
    boxes,
  };
}
